
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/signup",
      function () {
        return require("private-next-pages/partners/signup.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/signup"])
      });
    }
  